import React, { Component } from 'react'
import './style.scss'

export default class Layout extends Component {
    render() {
        return (
            <div className="page-wrap">
                {this.props.children}
            </div>
        )
    }
}
function inLayout(Component, params) {
    var createReactClass = require('create-react-class');
    return createReactClass({
        render: function() {
            var self = this
            return <Layout params={params}>
                <Component {...self.props} />
            </Layout>
        }
    });
}
export {
    inLayout
}


// WEBPACK FOOTER //
// ./src/layouts/Layout/Layout.js